import { reactive } from "vue";

export const store = reactive({
  countApprovals: 0,
  isMobile: false,
  isLastStep: false,
  isFirstStep: true,
});
